<template>
  <div>
    <breadcrumbs :back="back" home="Item reconciliation transactions"/>

    <purtrak-table name="reconcileitemtransactions" objectType="reconcile transactions" :defaultColumns="defaultColumns" :headers="headers" ref="table"
                   :nonPagedItems="itemReconciliation.transactions" listEndPoint="" fields=""
                   height="calc(100vh - 152px)"
                   @dblclick="item => viewTransaction(item)"
                   title="Item Reconciliation"
                   :print-info="{pageSize:'landscape',
                                 subTitle:[$formatDateTime(itemReconciliation.date),sites.length>1?itemReconciliation.site.name:null]}">
      <template v-slot:filter>
        <div class="text-caption mr-1">{{itemReconciliation.date | formatDateTime}}</div>
        <div v-if="sites.length > 1" class="text-caption mr-1">{{itemReconciliation.site.name}}</div>
      </template>

      <template v-slot:item.quantity="{item,value,printing}">
        <template v-if="printing">{{value | number(item.precision)}} item.units</template>
        <span :class="{'red--text':value<0}">{{value | number(item.precision)}} {{item.units}}</span>
      </template>
      <template v-slot:item.value="{value,printing}">
        <template v-if="printing">{{value | currency}}</template>
        <span :class="{'red--text':value<0}">{{value | currency}}</span>
      </template>
      <template v-slot:item.lot="{item,printing}">
        <template v-if="printing">{{item.lot}}</template>
        <v-hover v-else v-slot="{hover}">
          <a @click.stop="$router.push({name:'ReportsView',params:{back:[...back,{text:'Item reconciliation transactions',to:{name:'InventoryItemsReconcileTransactions',params:{id}}}]},query:{to:'reports/inventory/ReportsLot',id:item.id,lot:item.lot,forward:0}})"
             :class="{'text-decoration-underline':hover}">{{item.lot}}</a>
        </v-hover>
      </template>
      <template v-slot:item.action="{item}">
        <v-menu :nudge-width="150" offset-y>
          <template v-slot:activator="{ on }">
            <v-btn small v-on="on" v-if="$vuetify.breakpoint.mobile" outlined>Transaction operations</v-btn>
            <v-btn small icon v-on="on" v-else><v-icon small>mdi-dots-vertical</v-icon></v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="viewTransaction(item)"><v-list-item-title>Details</v-list-item-title></v-list-item>
            <v-list-item
                        :to="{name:'ReportsView',params:{back:[...back,{text:'Item reconciliation transactions',to:{name:'InventoryItemsReconcileTransactions',params:{id}}}]},query:{to:'reports/inventory/ReportsLot',id:item.id,lot:item.lot,forward:0}}"><v-list-item-title>Trace lot</v-list-item-title></v-list-item>
            <v-list-item v-if="audit" :to="{name:'Audit',query:{entityId:item.id}}"><v-list-item-title>Audit history</v-list-item-title></v-list-item>
            <template v-if="!readOnly">
              <v-divider/>
              <v-list-item @click="transaction=item;showDelete=true"><v-list-item-title>Delete transaction</v-list-item-title></v-list-item>
            </template>
          </v-list>
        </v-menu>
      </template>
    </purtrak-table>

    <delete-object v-model="showDelete" name="this transaction" @delete="performDeleteTransaction"/>
  </div>
</template>

<script>

export default {
  name: 'InventoryItemsReconcileTransactions',
  props: {
    id: {type:String, required:true}
  },
  data() {
    return {
      itemReconciliation: {transactions:[],site:{}},
      transaction: null,
      showDelete: false,
      defaultColumns: [{ value: 'name', visible:true},
                       { value: 'description', visible:true},
                       { value: 'lot', visible:true},
                       { value: 'quantity', visible:true},
                       { value: 'value', visible:false}],
      headers: [{ text: 'ITEM', value: 'name', width:'30%',sortable:true},
                { text: 'ACTIVITY', value: 'description', width:'30%',sortable:true},
                { text: 'LOT', value: 'lot', width:'10%',sortable:true},
                { text: 'QUANTITY', value: 'quantity', width:'20%',sortable:true,align:'right'},
                { text: 'VALUE', value: 'value', width:'15%',sortable:true,align:'right', omit:() => !this.values}]
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    sites() {
      return this.$store.getters.sites(true, this.itemReconciliation.bonded ? true : undefined);
    },
    values() {
      return this.company.permissions.includes('values');
    },
    readOnly() {
      return !this.company.permissions.includes('inventory.write');
    },
    audit() {
      return this.company.allowAudit && this.company.permissions.includes('audit');
    },
    back() {
      return [{text:'Items',to:{name:'InventoryItems'}},{text:'Item reconciliations',to:{name:'InventoryItemsReconcile'}}];
    }
  },
  async mounted() {
    this.loading = true;
    const results = await this.$apiCall(`query InventoryItemsReconcileTransactions($id:ID!) {
                                              itemReconciliation(id:$id) {
                                                date,site{name}
                                                transactions {
                                                  id,type,name,description,quantity,precision,units,value,lot
                                                }
                                              }
                                            }`,
                                        {id:this.id});
    if (!results.error)
      this.itemReconciliation = results.data.itemReconciliation;
    this.loading = false;
  },
  methods: {
    viewTransaction(transaction) {
      this.$router.push({name:'InventoryItemsAdjustInventory',params:{transactionId:transaction.id}});
    },
    async performDeleteTransaction() {
      this.loading = true;
      const results = await this.$apiCall(`mutation InventoryItemsReconcileTransactions($id: ID!) {
                                            objectDelete(id:$id)
                                          }`,
                                          {id:this.transaction.id});
      this.loading = false;
      if (!results.error) {
        this.showDelete = false;
        this.$refs.table?.buildList();
        this.$store.commit('setError', {type:'success',message:`Deleted ${this.transaction.description} transaction`});
      }
    }
  }
}
</script>